import { render } from "./StatistiquesSection.vue?vue&type=template&id=091584b0"
import script from "./StatistiquesSection.vue?vue&type=script&lang=js"
export * from "./StatistiquesSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__